module.exports = __webpack_public_path__ + "static/media/SelectedBuleBulb.e4c2d83f.svg";